(function() {
	function FrameToLensMap() {
		if (!window.prescription) {
			console.error('Please initialize Prescription Script before the FrameToLensMap.');
			return;
		}

		this.constants = window.PRESCRIPTION_CONSTANTS;

		this.hash = {};
		this.orphanedLenses = [];
		this.locale = window.prescription.locale;
		this.getCart(); // once after page load
	}

	/**
	 * Fetch the current cart.
	 * Look up the glasses and the lenses in the cart and try to match them via the glasses line item properties.
	 */
	FrameToLensMap.prototype.getCart = function() {
		var resolve;
		var reject;

		var handleResponseFunction = function(data, textStatus, request) {
			if (data) {
				if (this.buildMapFromResponse(data)) {
					resolve();
					return;
				}
			}
			reject(textStatus);
		};

		var asyncFunction = function(good, bad) {
			resolve = good;
			reject = bad;
			jQuery.get('/cart.js', null, handleResponseFunction.bind(this), 'json');
		};
		return new Promise(asyncFunction.bind(this));
	};

	/**
	 * Builds up the hash map to keep tack of glasses/lenses relationships in the cart
	 * @param cart JSON object, cart content coming from backend
	 * @returns boolean
	 */
	FrameToLensMap.prototype.buildMapFromResponse = function(cart) {
		if (cart.items.length === 0) {
			return false;
		}

		for (var index = 0; index < cart.items.length; index++) {
			var item = cart.items[index];
			if (this.isGlasses(item)) {
				var glassesHashIndex = item.key;
				if (!glassesHashIndex) {
					continue;
				}

				var lensVariantId = this.getLensVariantId(item);
				if (!lensVariantId) {
					continue;
				}
				this.hash[glassesHashIndex] = {
					lensVariantId: lensVariantId,
					glasses: item,
				};
			} else {
			}
		}

		return true;
	};

	/**
	 * Tests if the line item in question are glasses
	 * @param lineItem
	 * @returns boolean
	 */
	FrameToLensMap.prototype.isGlasses = function(lineItem) {
		return lineItem.product_type === this.constants.GLASS_PRODUCT_TYPE;
	};

	/**
	 * LineItem Properties contain the variant ID of the lens,
	 * which is extracted and returned here.
	 * @param lineItem of Glasses type
	 * @returns string
	 */
	FrameToLensMap.prototype.getLensVariantId = function(lineItem) {
		var properties = lineItem.properties;
		var lensVariantKey = this.locale['lens_variant_id'] || 'lens_variant_id';

		if (!properties) return null;
		if (!properties[lensVariantKey]) return null;

		return properties[lensVariantKey];
	};

	/**
	 * Attaches Decorator Functions for the +/- buttons in the cart.
	 *
	 * @returns void
	 */
	FrameToLensMap.prototype.decorateCartQuantityButtons = function() {
		if (!theme.QtySelector) {
			console.error('Cannot decorate QtySelector');
			return;
		}

		// handler function will be bound to QtySelector, so a second ref is needed
		var mapRef = this;

		var handleAdd = function(number) {
			var lineItemKey = this.$input[0].dataset.id;
			var reboundFunction = mapRef.handleQuantityChange.bind(mapRef);
			return reboundFunction(number + 1, lineItemKey);
		};

		var handleSubtract = function(number) {
			var lineItemKey = this.$input[0].dataset.id;
			var reboundFunction = mapRef.handleQuantityChange.bind(mapRef);
			return reboundFunction(number - 1, lineItemKey);
		};

		this.decorate('addQty', handleAdd);
		this.decorate('subtractQty', handleSubtract);
		// this.decorate(''); // TODO: Pick it up here
		/**
		 * Plan:
		 * 'change' Event aller inputs überschreiben.
		 * Dort QtySelector wieder aufrufen, nachdem geprüft wird ob wir das wollen.
		 */
	};

	/**
	 * Apply decorations.
	 * Replaces the QtySelector function of functionName, executes
	 * local code and then - if we allow it, executes the original function.
	 *
	 * @param functionName string
	 * @param replaceFunction Function
	 */
	FrameToLensMap.prototype.decorate = function(functionName, replaceFunction) {
		// get a reference to the original function
		var originalFunction = theme.QtySelector.prototype[functionName];

		// build the decorator
		var decoratorFunction = function(number) {
			// scope
			var QtySelectorInstance = this;
			var boundFunction = replaceFunction.bind(QtySelectorInstance);

			// call replacement function
			var updatePromise = boundFunction(number);
			if (!updatePromise) {
				console.log('No promise created, user shall not change lens quantity');
				return;
			}
			updatePromise.then(function(quantityIsAllowedToChange) {
				if (quantityIsAllowedToChange) {
					// call original function
					originalFunction.call(QtySelectorInstance, number);
				} else {
					console.log('User shall not change lens quantity');
				}
			});
		};

		// replace original function with decorator function
		theme.QtySelector.prototype[functionName] = originalFunction;
	};

	/**
	 * Actual Decorator for the +/- buttons of the cart.
	 * Fetches the correct lens for glasses that are already in the cart
	 * and calls the update method for keep the amount of glasses and
	 * needed lenses in sync.
	 *
	 * @see FrameToLensMap.prototype.decorateCartQuantityButtons
	 * @param quantity number
	 * @param key string
	 * @returns Promise
	 */
	FrameToLensMap.prototype.handleQuantityChange = function(quantity, key) {
		// get the lens line item by looking up glasses data.
		// get glasses data from the cart by using the cartKey.
		var hashValue = this.hash[key];

		// stop when the item is not some glasses / i.e. no glasses hashed
		if (!hashValue) {
			return null;
		}

		var lenses = hashValue.lensVariantId;

		// two lenses in each glasses
		var lensQuantity = quantity * 2;

		var asyncFunction = function(resolve) {
			this.updateLensCountInCart(lensQuantity, lenses).then(function() {
				resolve(true);
			});
		}.bind(this);

		return new Promise(asyncFunction);
	};

	/**
	 * Sends the update request to the backend
	 * @param quantity number
	 * @param lensVariantId string
	 * @returns Promise
	 */
	FrameToLensMap.prototype.updateLensCountInCart = function(quantity, lensVariantId) {
		var payload = {
			updates: {
				[lensVariantId]: quantity,
			},
		};

		// scoped reference
		var resolve;

		var handleResponseFunction = function(data, textStatus, request) {
			if (data && textStatus === 'success') {
				var jsonData = JSON.parse(data);
				this.buildMapFromResponse(jsonData);
				resolve();
			} else {
				var error = {
					data: data,
					textStatus: textStatus,
					request: request,
				};
				reject(error);
			}
		}.bind(this);

		return new Promise(function(yes) {
			resolve = yes;
			jQuery.post('/cart/update.js', payload, handleResponseFunction);
		});
	};

	// other scripts need to load first
	setTimeout(function() {
		// attach map to window
		window.frameToLensMap = new FrameToLensMap();
		window.frameToLensMap.decorateCartQuantityButtons();

		// replace the theme cart update function to rebuild the hash after cart changes
		/*
		window.theme.cart._updateCart = function(params) {
			return $.ajax(params).then(
				function(cart) {
					window.frameToLensMap.getCart();
					return cart;
				}.bind(window.theme.cart)
			);
		};*/
	}, 500);
})();
